<!-- <div class="modal-dialog"> -->
<div class="modal-content">
  <div class="modal-header">

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
  </div>
  <div class="modal-body">
    <!-- <div class="grid-structure"> -->
    <!-- <div class="row"> -->
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-3">
          <span *ngIf="mode == 'PAY'">{{ 'LABELS.THANK_YOU' | translate}}</span>{{ 'LABELS.NEFT_PAYMENT_INFO' |
          translate}}
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- <div class="row" class="virtualAccContainer"> -->
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-3">
          <div class="row" class="accNam">{{ 'LABELS.ACCOUNT_NUMBER' | translate}} : {{data.accntNo}}</div>
          <div class="row" class="ifscCode">{{ 'LABELS.IFSC_CODE' | translate}} : {{data.ifscCode}}</div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-3">
          <!-- <div class="Nefttxt2"> -->
          {{ 'LABELS.MAKE_PAYMENT_INFO' | translate}}
          <!-- </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="row"*ngIf="data.banks && data.banks.length"> -->
    <div class="row" *ngIf="data.banks && data.banks.length">
      <div class="col-12">
        <div class="form-group mb-3">
          <select class="form-control" name="payUsing" [(ngModel)]="data.selectedBank">
            <option value="" disabled>{{ 'LABELS.SELECT_YOUR_BANK' | translate}}</option>
            <option *ngFor="let bank of data.banks" [ngValue]="bank">{{bank.bankName || bank.bankNm}}</option>
          </select>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="row button-list">
      <div class="col-12">
        <button class="btn fis-btn waves-effect" data-dismiss="modal" (click)="close()">
          {{ 'LABELS.CLOSE' | translate}}
        </button>
      <!-- </div>
      <div class="col-6"> -->
        <button class="btn  fis-btn" [disabled]="!data.selectedBank || !data.selectedBank.bankUrl"
          (click)="goToBank()">
          {{ 'LABELS.GO_TO_BANK' | translate}}
        </button>
      </div>
    </div>
    <!-- </div> -->
  </div>


</div>
<!-- </div> -->